// extracted by mini-css-extract-plugin
export default {"hint":"styles_hint__YEXar"};